import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editMutations } from './types';

const edit = {
	AphlasPrp: null as boolean | null,
	CenShoraPrp: null as boolean | null,
	DodavatelId: null as number | null,
	DodavatelIdText: null as string | null,
	GdNr: null as string | null,
	MioTiskPrp: null as boolean | null,
	NdakcegenPrp: null as boolean | null,
	ObchodnikNr: null as string | null,
	PsdnahradaPrp: null as boolean | null,
	RyopiaskPrp: null as boolean | null,
	Text: null as string | null,
	VyrobekndOzn: null as string | null,
	VyrobekvozOzn: null as string | null,
	ZaznamId: null as number | null,
	KoncernPrp: null as boolean | null,
	QuoteExpiryDays: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		VyrobekndOzn: [],
		GdNr: [],
	},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {
		[editMutations.VYROBEK_ND_DODAVATEL_SELECT_MAPPER](state, { data }) {
			state.edit.DodavatelId = data.value;
			state.edit.DodavatelIdText = data.text;
		},
	},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
